import { render, staticRenderFns } from "./AboutSite.vue?vue&type=template&id=de01870a&"
import script from "./AboutSite.vue?vue&type=script&lang=js&"
export * from "./AboutSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports